__turbopack_context__.v({
  "input": "CheckTemplate-module-scss-module__UhcYoq__input",
});
